import { AINewsConstants } from "../Constants/AINewsConstants";
import SymbolType from "SymbolType";
const { ActionTypes } = AINewsConstants;

const initialState = {
  isReqActive: false,
  message: "Loading ...",
  competitiveEdgeData: "",
  zigzagTrendData: "",
  financialBlockMetricsData: "",
  trackPriceAINews: "",
  applicableInstrumentsCompEdge: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ],
  applicableInstrumentsZigzag: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ],
  applicableFinancialBlockMetricsData: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ],
  applicableInstrumentsTrackPriceAI: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ],
  applicableInstrumentsFutureEventsAI: [
    SymbolType.USSTOCK,
    SymbolType.ADR,
    SymbolType.PREIPO,
    SymbolType.REIT,
  ],
  savedReactions: {},
  showAIPopup: false,
  triggerClose: false,
  popupConfig: {},
  futureEvents: [],
  futureEventsOriginal: [],
  futureEventsResponse: null,
  aiFutureEventsGutterQtr: 0,
};

const AINewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MESSAGE:
      return {
        ...state,
        message: action.message,
      };

    case ActionTypes.GET_COMPETITIVE_EDGE_REQUEST:
      return {
        ...state,
        competitiveEdgeData: "",
        message: "Loading ...",
        isReqActive: true,
      };

    case ActionTypes.GET_COMPETITIVE_EDGE_SUCCESS:
    case ActionTypes.GET_COMPETITIVE_EDGE_FAILURE:
      return {
        ...state,
        competitiveEdgeData: action.data,
        message: action.message,
        isReqActive: false,
      };

    case ActionTypes.GET_ZIGZAG_TREND_DATA_REQUEST:
      return {
        ...state,
        zigzagTrendData: "",
        message: "Loading ...",
        isReqActive: true,
      };

    case ActionTypes.GET_ZIGZAG_TREND_DATA_SUCCESS:
    case ActionTypes.GET_ZIGZAG_TREND_DATA_FAILURE:
      return {
        ...state,
        zigzagTrendData: action.data,
        message: action.message,
        isReqActive: false,
      };
    case ActionTypes.SAVE_AI_REACTIONS:
      const { index, text, reaction, comments, date } = action;
      const reactions = {
        ...state.savedReactions,
        [index]: { text, reaction, comments, date },
      };
      return {
        ...state,
        savedReactions: reactions,
      };
    case ActionTypes.CLEAR_REACTIONS:
      return {
        ...state,
        savedReactions: {},
      };
    case ActionTypes.GET_FINANCIAL_BLOCK_METRICS_DATA_REQUEST:
      return {
        ...state,
        financialBlockMetricsData: "",
        message: "Loading ...",
        isReqActive: true,
      };    

    case ActionTypes.GET_FINANCIAL_BLOCK_METRICS_DATA_SUCCESS:
    case ActionTypes.GET_FINANCIAL_BLOCK_METRICS_DATA_FAILURE:
      return {
        ...state,
        financialBlockMetricsData: action.data,
        message: action.message,
        isReqActive: false,
      };
    case ActionTypes.SET_POPUP_CONFIG:
      return {
        ...state,
        showAIPopup: action.showAIPopup,
        popupConfig: action.popupConfig
      };
    case ActionTypes.CLEAR_POPUP_CONFIG:
      return {
        ...state,
        showAIPopup: false,
        popupConfig: {}
      };
    case ActionTypes.GET_TRACK_PRICE_AI_NEWS_REQUEST:
      return {
          ...state,
          trackPriceAINews: "",
          message: "Loading ...",
          isReqActive: true
      }

    case ActionTypes.GET_TRACK_PRICE_AI_NEWS_SUCCESS:
    case ActionTypes.GET_TRACK_PRICE_AI_NEWS_FAILURE:
      return {
          ...state,
          trackPriceAINews: action.data,
          message: action.message,
          isReqActive: false
      }
    case ActionTypes.CLOSE_POPUP:
      return {
        ...state,
        showAIPopup: false,
      };
    
    case ActionTypes.UPDATE_FUTURE_EVENTS:
      return {
        ...state,
        ...action.states,

      };

    case ActionTypes.SET_TRIGGER_CLOSE:
      return {
        ...state,
        triggerClose: action.triggerClose,
      }

    case ActionTypes.SET_AI_FUTURE_EVENTS_GUTTER_QTR:
      return {
        ...state,
        aiFutureEventsGutterQtr: action.aiFutureEventsGutterQtr
      };

    default:
      return state;
  }
};

export default AINewsReducer;
